export enum DocumentType {
  COMID = 'comid',
  COMRES = 'comres',
  COMPASS = 'compass',
}

export enum PassportType {
  ORDINARY = 'ordinary',
  SERVICE = 'service',
  DIPLOMATIC = 'diplomatic'
}

export enum DocumentRequestReason {
  FIRST_REQUEST = 'FIRST_REQUEST',
  OTHER = 'OTHER',
  DUPLICATE_DESTRUCTION = 'DUPLICATE_DESTRUCTION',
  DUPLICATE_LOSS = 'DUPLICATE_LOSS',
  MODIFICATION = 'MODIFICATION',
  PAGE_COMPLETED = 'PAGE_COMPLETED',
  RENEWAL = 'RENEWAL'
}

export const VisaTypes = {
  COMID: DocumentType.COMID,
  COMPASS: DocumentType.COMPASS,
  COMRES: DocumentType.COMRES
} as const;

export const ExtensionTypes = {
} as const;

export type VisaType = typeof VisaTypes[keyof typeof VisaTypes];
export type ExtensionType = typeof ExtensionTypes[keyof typeof ExtensionTypes];

export const DocumentTypeInTablePattern = /.*/;
